<template>
  <el-dialog
    v-dialogDrag
    title="选择出卷策略"
    :visible.sync="visible"
    :close-on-click-modal="false"
    class="large-dialog"
    :before-close="close"
  >
    <div class="w-full h-full" v-loading="tableLoading">
      <div class="flex items-center">
        <el-input
          v-model="keyword"
          placeholder="搜索策略名称"
          size="medium"
          clearable
          class="w-250px mr-10px"
          @keyup.enter.native="sizeChange"
        ></el-input>
        <el-button type="primary" size="medium" @click="sizeChange">搜索</el-button>
      </div>
      <el-table
        :data="tableDataList"
        border
        @select="tableSelection"
        class="w-full mt-10px"
        height="calc(100% - 86px)"
        ref="multipleTable"
        stripe
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="75"></el-table-column>
        <el-table-column
          label="策略名称"
          prop="Name"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="知识点所在章节"
          prop="ChapterSourceName"
          show-overflow-tooltip
          min-width="150px"
        ></el-table-column>
        <el-table-column
          label="单选题数量"
          prop="SingleChoiceCount"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="单选题分值"
          prop="SingleChoiceScore"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="多选题数量"
          prop="MultipleChoiceCount"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="多选题分值"
          prop="MultipleChoiceScore"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="判断题数量"
          prop="JudgmentCount"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="判断题分值"
          prop="JudgmentScore"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="填空题数量"
          prop="FillBlanksCount"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="填空题分值"
          prop="FillBlanksScore"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="简答题数量"
          prop="ShortAnswerCount"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="简答题分值"
          prop="ShortAnswerScore"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="试卷总分"
          prop="TotalScore"
          show-overflow-tooltip
          min-width="120px"
        ></el-table-column>
        <el-table-column
          label="策略作用"
          prop="Effect"
          show-overflow-tooltip
          min-width="200px"
        ></el-table-column>
      </el-table>
      <el-pagination
        class="mt-10px text-right"
        @size-change="sizeChange"
        @current-change="getTableData"
        :current-page.sync="pageNo"
        :page-sizes="[15, 30, 40, 80, 100]"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="confirmSelect">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { QuestionChapterApi } from '@wiz-api/exam-management'
import DiyService from '../../services/DiyService.js'

const questionChapterApi = new QuestionChapterApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableLoading: false,
      pageNo: 1,
      pageSize: 15,
      totalNum: 0,
      keyword: '',
      tableDataList: [],
      questionChapterList: [],
      selectId: '',
    }
  },
  async created() {
    this.tableLoading = true
    await this.getQuestionChapter()
    this.getTableData()
  },
  methods: {
    tableSelection(rows) {
      if (rows.length > 1) {
        rows.shift()
        this.$refs.multipleTable.clearSelection()
        this.$refs.multipleTable.toggleRowSelection(rows[0], true)
      }
      if (rows.length) {
        this.selectId = rows[0].Id
      }
    },
    confirmSelect() {
      if (!this.selectId) {
        this.$message.warning('请选择出卷策略！')
        return
      }
      this.$emit('save', this.selectId)
    },
    close() {
      this.$emit('close')
    },
    sizeChange() {
      this.pageNo = 1
      this.getTableData()
    },
    async getQuestionChapter() {
      const [err, res] = await questionChapterApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.questionChapterList = res.items
      }
    },
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await DiyService.getTableData({
        TableName: 'diy_QuestionStrategy',
        _PageSize: this.pageSize,
        _PageIndex: this.pageNo,
        _Where: [{ Name: 'Name', Value: this.keyword, Type: 'Like' }],
      })
      this.tableLoading = false
      if (!err && res && res.Code === 1 && res.Data) {
        this.tableDataList = _.map(res.Data, (item) => {
          // const currentChapter = _.find(this.questionChapterList, ['id', item.ChapterSource])
          const chapterSourceList = item.ChapterSource ? JSON.parse(item.ChapterSource) : []
          const nameList = []
          _.forEach(chapterSourceList, (ids) => {
            if (Array.isArray(ids)) {
              const itemList = []
              _.forEach(ids, (id) => {
                const currentChapter = _.find(this.questionChapterList, (source) => { return source.id === id })
                if (currentChapter) {
                  itemList.push(currentChapter.title)
                }
              })
              nameList.push(itemList.join('/'))
            }
          })
          return { ...item, ChapterSourceName: nameList.join(', ') }
        })
        this.totalNum = res.DataCount
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__header-wrapper .el-table__header .el-checkbox {
  display: none;
}
</style>
